import React, { useRef } from 'react';
var VeltSingleEditorModePanel = function (props) {
    var children = props.children, shadowDom = props.shadowDom, variant = props.variant, darkMode = props.darkMode;
    var ref = useRef();
    return (React.createElement("velt-single-editor-mode-panel", { ref: ref, variant: variant, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};
export default VeltSingleEditorModePanel;
